require('./standard-addrselect-searchbox.scss');
require('./standard-addrselect-searchbox-ycs.scss');
import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../../intl/helper';
import muiText from '../../../intl/messages/mui';
const React = require('react');
const classnames = require('classnames');
// const getCityList = require('../../../helper/city-helper.js').getCityList;

module.exports = React.createClass({
  displayName: 'StandardAddrSelectSearchBoxYCS',
  propTypes:{
    // hotCityList: React.PropTypes.array,
    currentCity: React.PropTypes.object,
    placeholder: React.PropTypes.string,
    suggestVisible: React.PropTypes.bool,
    suggest: React.PropTypes.array,
    onUserInput: React.PropTypes.func,
    onSetSuggestVisible: React.PropTypes.func.isRequired,
    onSelectComplete: React.PropTypes.func,
    onCurrentCityChange: React.PropTypes.func,
    // 12-27 frank add
    showCityChangeList: React.PropTypes.bool,
    onShowCityChangeList: React.PropTypes.func,
    notFindCityButton: React.PropTypes.string,
    triggerCityChange: React.PropTypes.func,
    cityList: React.PropTypes.array,
    hasNearChosen: React.PropTypes.bool, // 是否需要展示附近门店
    dinningChange: React.PropTypes.func, // YCS 选项卡
  },
  getDefaultProps() {
    return {
      placeholder: '请录入关键字',
      suggest: [],
    };
  },
  getInitialState() {
    return {
      searchValueIsEmpty: true,
      cityPopupVisible: false,
    };
  },
  componentWillReceiveProps(nextProps) {
    if (nextProps.suggestVisible) {
      this.toggleCityPopup(false);
    }
    if (nextProps.showCityChangeList && !nextProps.suggestVisible) {
      this.setState({ cityPopupVisible:true });
    }
  },
  getCityPopupElement() {
    const { hasNearChosen } = this.props;

    return (
      <div className="city-popup" /* onTouchTap={this.handleCityTap} */>
        {
          hasNearChosen &&
            <div className="city-recommend">

              <h3 className="city-title">
                <FormattedMessage {...muiText.muidiningRoom} />
              </h3>
              <p className="city-list clearfix">
                <a href=" javascript:void(0)" data-value={0} onTouchTap={this.handleDinningTap}>一<FormattedMessage {...muiText.muidiningRoom} /></a>
                {/* <a href=" javascript:void(0)" data-value={1} onTouchTap={this.handleDinningTap}>二食堂</a>
                <a href=" javascript:void(0)" data-value={2} onTouchTap={this.handleDinningTap}>三食堂</a> */}
              </p>
            </div>
        }
      </div>
    );
  },
  handleChange(evt) {
    const value = evt.target.value;
    if (this.props.onUserInput) {
      this.props.onUserInput(value.trim());
    }
    this.setState({ searchValueIsEmpty: !value });
  },
  handleInputClick(evt) {
    if (!this.props.suggest.length) {
      return;
    }

    this.props.onSetSuggestVisible();
  },
  handleItemTouchTap(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    if (!this.props.onSelectComplete) {
      return;
    }

    const target = evt.currentTarget;
    const data = target.dataset;
    const pos = this.props.suggest[data.index];
    if (!pos) {
      return;
    }

    const ret = {
      title: pos.title,
      address: pos.address,
      point: {
        longitude: pos.point.lng.toString(),
        latitude: pos.point.lat.toString(),
      },
    };

    this.refs.input.value = pos.address;
    this.props.onSetSuggestVisible(false);
    this.props.onSelectComplete(ret);
  },
  handleBtnClose(evt) {
    evt.preventDefault();
    this.refs.input.value = '';
    if (this.props.onUserInput) {
      this.props.onUserInput('');
    }
    this.props.onSetSuggestVisible(false);
    this.setState({ searchValueIsEmpty: true });
  },
  handleDinningTap(evt) {
    const target = evt.target;
    const dataset = target.dataset;
    const dinningName = target.text;
    const dinningObj = { dinningName, value: dataset.value };
    const { dinningChange, currentCity } = this.props;

    if (dataset.value && (!currentCity || currentCity.name !== name)) {
      if (dinningChange) {
        dinningChange(dinningObj);
        this.refs.input.value = '';
      }
    }

    this.toggleCityPopup();
  },
  toggleCityPopup(visible) {
    this.setState({ cityPopupVisible: visible === undefined ? !this.state.cityPopupVisible : visible }, () => {
      const { cityPopupVisible } = this.state;
      const { onShowCityChangeList } = this.props;
      if (cityPopupVisible) {
        if (onShowCityChangeList) {
          onShowCityChangeList();
        }
        this.props.onSetSuggestVisible(false);
      }
    });
  },
  render() {
    let items = this.props.suggest.map((item, index) => (
      <li key={index}>
        <button
          className="addrselect-suggestion"
          onTouchTap={this.handleItemTouchTap}
          data-index={index}
          data-name={item.title}
          data-latitude={item.point.lat}
          data-longitude={item.point.lng}
        >
          {item.title}
          <small>{item.address}</small>
        </button>
      </li>
    ));
    const currentCity = this.props.currentCity;
    const { searchValueIsEmpty, cityPopupVisible } = this.state;
    return (
      <div
        className={
          classnames(
            'o-flex addrselect-header addrselect-header--ycs',
            {
              'city-expand': cityPopupVisible,
              'suggest-expand': this.props.suggestVisible && items.length !== 0,
            }
          )
        }
        ref="wrap"
      >
        {cityPopupVisible && <div className="addrselect-bg"></div>}
        <span
          className="city-select"
          onTouchTap={() => { this.toggleCityPopup(); }}
        >
          {currentCity && currentCity.name || ''}
        </span>
         {cityPopupVisible && this.getCityPopupElement()}
        <label className={classnames('o-flex__fluid addrselect-searchbox', { 'is-empty': searchValueIsEmpty })}>
          <span className="addrselect-search-icon addrselect-search-icon--modify"></span>

          {
            !searchValueIsEmpty &&
              <button className="addrselect-search-close" onTouchTap={this.handleBtnClose}></button>
          }
          <div className="of">
            <input
              type="text"
              ref="input"
              className="addrselect-search-input"
              placeholder={this.props.placeholder}
              onTouchTap={this.handleInputClick}
              onChange={this.handleChange}
              maxLength="30"
            />
          </div>
        </label>
        {
          items.length !== 0 &&
            <ul className="addrselect-suggestions" style={{ display: this.props.suggestVisible ? 'block' : '' }}>
              {items}
              {
                this.props.notFindCityButton === 'notFindCityButton' && items.length !== 0 &&
                  <li className="cityNotfind" onTouchTap={this.props.triggerCityChange}><FormattedMessage {...muiText.muichangeCity} /></li>
              }
            </ul>
        }
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/mui/standard-addrselect/standard-addrselect-searchbox-ycs.jsx